import type { ReactNode } from "react";

import { ConfirmProvider } from "./ui/confirm";
import { NotificationProvider } from "./ui/toast";
import { TooltipProvider } from "./ui/tooltip";

/** What every page may use: confirmations, notices and tooltips (M31). */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <TooltipProvider delayDuration={300}>
      <NotificationProvider>
        <ConfirmProvider>{children}</ConfirmProvider>
      </NotificationProvider>
    </TooltipProvider>
  );
}
